/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamDisciplineDropdownFiltered200,
  GetApiV1ExamDisciplineDropdownFiltered400,
  GetApiV1ExamDisciplineDropdownFiltered401,
  GetApiV1ExamDisciplineDropdownFiltered500,
  GetApiV1ExamDisciplineDropdownFilteredQueryParams,
  GetApiV1ExamDisciplineDropdownFilteredQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamDisciplineDropdownFiltered.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1ExamDisciplineDropdownFilteredQueryParamsSchema = z.object(
  {
    filter: z.optional(z.string()),
    courseModality: z.optional(z.coerce.number().int()),
    companyId: z.optional(z.coerce.number().int()),
    courseId: z.optional(z.coerce.number().int()),
    bringMain: z.boolean().default(false),
    classroomId: z.optional(z.coerce.number().int()),
    cultureInfo: z.string().default("pt-BR"),
  },
) as unknown as ToZod<GetApiV1ExamDisciplineDropdownFilteredQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamDisciplineDropdownFiltered200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1ExamDisciplineDropdownFiltered200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamDisciplineDropdownFiltered400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDisciplineDropdownFiltered400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamDisciplineDropdownFiltered401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDisciplineDropdownFiltered401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamDisciplineDropdownFiltered500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDisciplineDropdownFiltered500>;

export const getApiV1ExamDisciplineDropdownFilteredQueryResponseSchema = z.lazy(
  () => getApiV1ExamDisciplineDropdownFiltered200Schema,
) as unknown as ToZod<GetApiV1ExamDisciplineDropdownFilteredQueryResponse>;
